/* eslint-disable react/jsx-no-undef */
import * as React from 'react'
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';

import { AboutUsContent, BaseDiv, DoubleInput, TextBody, TextContent } from './styles';
import Button from '../../../../../Button';
import FormService from '../../../../../../services/form';
import { useToast } from '../../../../../../hooks/toast';
import Input from './Input';

interface INavBar {
    
}
const formService = new FormService();

const Formulario: React.FC<INavBar> = () => {

    const formRef = React.useRef<FormHandles>(null);
  const { addToast } = useToast();

  const handleSubmit = React.useCallback(
    async (data: any) => {
      try {
        formRef.current?.setErrors({});
        const response = await formService.postContato({
          origin: `landing`,
          name: data.name,
          email: data.email,
          phone: data.phone,
          name_company: data.name_company,
          message: data.message,
        });
        addToast({
          type: 'success',
          title: 'Formulário enviado',
          description: 'Formulário enviado com sucesso',
        });
        formRef.current?.reset();
      } catch (err: any) {
        console.log(err);
        addToast({
          type: 'error',
          title: 'Erro ao enviar o formulário',
          description: 'Verifique se todos os campos estão preenchidos corretamente.',
        });
      }
    },
    [addToast]
  );

    return (
        <BaseDiv>
            <AboutUsContent>
                <TextContent>
                    <TextBody>
                        <Form ref={formRef} onSubmit={handleSubmit} placeholder={undefined}>
                            <Input name='name' placeholder='Nome'/>
                            <Input name='name_company' placeholder='Empresa'/>
                            <Input name='phone' placeholder='Telefone' />
                            <Input name='email' placeholder='E-mail'/>
                            <Input name='message' placeholder='Digite sua mensagem'/>
                            <Button color='orange' padding={'10px'}type="submit" style={{ color: 'white' }}>
                              ENVIAR
                            </Button>
                        </Form>
                    </TextBody>
                </TextContent>
            </AboutUsContent>
        </BaseDiv>
    );
}

export { Formulario }